import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-100 d-flex mt-3" }
const _hoisted_2 = { class: "w-75 d-flex justify-end pr-5" }
const _hoisted_3 = { class: "w-100 d-flex mt-3" }
const _hoisted_4 = { class: "w-75 d-flex justify-start pl-5" }

import getDeliveryPlanVehicleInformation from '@/types/responses/getDeliveryPlanVehicleInformation';
import ValidationErrors from '@/components/Common/ValidationErrors.vue';
import { VueDatePicker } from '@vuepic/vue-datepicker';
import { formatDateTime } from '@/services/functions';
import '@vuepic/vue-datepicker/dist/main.css'
import { ja } from 'date-fns/locale'
import { computed } from 'vue';
import i18n from '@/lang/i18n';

export default /*@__PURE__*/_defineComponent({
  __name: 'SplitFormDetail',
  props: {
    modelValue: {},
    deliveryPlan: {},
    errorMessages: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit

const props = __props;

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
  },
})

const splitReturningMaxDate = computed(() => {
  return modelValue.value.splitLeavingTime ?? props.deliveryPlan.returning_warehouse_date_time;
});

const splitLeavingMinDate = computed(() => {
  return modelValue.value.splitReturningTime ?? props.deliveryPlan.leaving_warehouse_date_time;
});

function changeFormat(dateTime: string | null) {
  return dateTime ? formatDateTime(new Date(dateTime)) : '';
}

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_col, { cols: "2" }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.splitForm.leavingWarehouse')), 1),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(changeFormat(props.deliveryPlan.leaving_warehouse_date_time)), 1),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "w-25 mx-auto" }, " ～ ", -1))
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_v_col, {
      cols: "3",
      class: "mr-4"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.splitForm.firstHalfReturningWarehouse')), 1),
        _createVNode(ValidationErrors, {
          messages: props.errorMessages.returning_warehouse_date_time
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(VueDatePicker), {
              class: "mt-1",
              modelValue: modelValue.value.splitReturningTime,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue.value.splitReturningTime) = $event)),
              locale: _unref(ja),
              clearable: false,
              formats: { input: 'yyyy-MM-dd HH:mm' },
              enableSeconds: false,
              "time-config": { enableSeconds: true },
              "min-date": props.deliveryPlan.leaving_warehouse_date_time,
              "max-date": splitReturningMaxDate.value,
              teleport: "body"
            }, null, 8, ["modelValue", "locale", "min-date", "max-date"])
          ]),
          _: 1
        }, 8, ["messages"])
      ]),
      _: 1
    }),
    _createVNode(_component_v_divider, {
      vertical: "",
      class: "my-4"
    }),
    _createVNode(_component_v_col, {
      cols: "3",
      class: "ml-4"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.splitForm.secondHalfLeavingWarehouse')), 1),
        _createVNode(ValidationErrors, {
          messages: props.errorMessages.leaving_warehouse_date_time
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(VueDatePicker), {
              class: "mt-1",
              modelValue: modelValue.value.splitLeavingTime,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modelValue.value.splitLeavingTime) = $event)),
              locale: _unref(ja),
              clearable: false,
              formats: { input: 'yyyy-MM-dd HH:mm' },
              enableSeconds: false,
              "time-config": { enableSeconds: true },
              "min-date": splitLeavingMinDate.value,
              "max-date": props.deliveryPlan.returning_warehouse_date_time,
              teleport: "body"
            }, null, 8, ["modelValue", "locale", "min-date", "max-date"])
          ]),
          _: 1
        }, 8, ["messages"])
      ]),
      _: 1
    }),
    _createVNode(_component_v_col, { cols: "2" }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.splitForm.returningWarehouse')), 1),
        _createElementVNode("div", _hoisted_3, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "w-25 mx-auto" }, " ～ ", -1)),
          _createElementVNode("div", _hoisted_4, _toDisplayString(changeFormat(props.deliveryPlan.returning_warehouse_date_time)), 1)
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})